import { required, optional, array, obj } from 'AppReact/schema';

const mapping = {
    type: required('string'),
    external_display: required('string'),
    external_value: required('string'),
    internal_value: optional('string'),
    internal_display: optional('string')
}

export default {
    categories: array(obj(mapping)),
    reasons: array(obj(mapping)),
    statuses: array(obj(mapping)),
    priorities: array(obj(mapping))
}